import {ValueObject} from '@s-ui/domain'

export class AdReservationStatusTransactionsValueObject extends ValueObject {
  #adId
  #adReservationStatus
  #reservationId

  constructor({adId, adReservationStatus, reservationId}) {
    super()
    this.#adId = adId
    this.#adReservationStatus = adReservationStatus
    this.#reservationId = reservationId
  }

  static createFromApi({adId, adReservationStatus, reservationId}) {
    return new AdReservationStatusTransactionsValueObject({adId, adReservationStatus, reservationId})
  }

  get adId() {
    return this.#adId
  }

  get adReservationStatus() {
    return this.#adReservationStatus
  }

  get reservationId() {
    return this.#reservationId
  }

  get value() {
    return {
      adId: this.#adId,
      adReservationStatus: this.#adReservationStatus,
      reservationId: this.#reservationId
    }
  }
}
